import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import './ToolPage.css';

export default function Estimator() {
  const iframeRef = useRef(null);
  const navigate = useNavigate();
  const [iframeReady, setIframeReady] = useState(false);
  const { theme, fontSize } = useTheme();

  // Push current display settings into the iframe
  const syncSettings = useCallback(() => {
    iframeRef.current?.contentWindow?.postMessage(
      { type: 'SET_THEME', theme, fontSize },
      '*'
    );
  }, [theme, fontSize]);

  useEffect(() => {
    if (!iframeReady) return;
    syncSettings();
  }, [iframeReady, syncSettings]);

  useEffect(() => {
    function handleMessage(event) {
      if (!event.data || typeof event.data !== 'object') return;
      switch (event.data.type) {
        case 'ESTIMATOR_READY':
          setIframeReady(true);
          // Echo settings immediately so the iframe paints in the right theme
          setTimeout(() => {
            iframeRef.current?.contentWindow?.postMessage(
              { type: 'SET_THEME', theme, fontSize },
              '*'
            );
          }, 50);
          break;
        case 'NAVIGATE_TO_PLANNER':
          navigate('/detailed-planner');
          break;
        default:
          break;
      }
    }
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [navigate, theme, fontSize]);

  return (
    <div className="tool-page">
      <div className="tool-toolbar">
        <div className="tool-toolbar-left">
          <h2 className="tool-title">Retirement Spending Estimator</h2>
        </div>
      </div>

      <div className="tool-frame-wrapper">
        <iframe
          ref={iframeRef}
          src="/tools/estimator.html"
          title="Retirement Spending Estimator"
          className="tool-iframe"
          sandbox="allow-scripts allow-same-origin allow-forms allow-downloads"
        />
      </div>
    </div>
  );
}